__turbopack_context__.v({
  "className": "_VnrhG_className",
  "variable": "_VnrhG_variable",
});
